// extracted by mini-css-extract-plugin
module.exports = {"container":"sectionHeader_container__2Wl9v","actions":"sectionHeader_actions__1K3ea","actionBtn":"sectionHeader_actionBtn__2h0q_"};